import { setUsageLimit } from './usage-limit-slice';

import { ApiService } from 'js/src/client';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch } from 'js/src/libs/RootState';

/**
 * Fetches and sets the usage limits for the current user's team
 * @param excluded_video_id We typically do not want to include the current video in the usage limits because it's still in progress and will be added in the frontend
 */
export function loadUsageLimits(excluded_video_id: number | undefined = undefined) {
    return (dispatch: AppDispatch) => {
        ApiService.usageLimitsRetrieve({
            query: { excluded_video_id: excluded_video_id },
        })
            .then((response) => {
                dispatch(setUsageLimit(response.data));
            })
            .catch((error) => {
                ErrorReporter.capture(error);
            });
    };
}
